// extracted by mini-css-extract-plugin
module.exports = {"avatarList":"avatar-list-module--avatarList--1ELM9","hrefBox":"avatar-list-module--hrefBox--YDVYq"};